import 'core-js/features/url';
import 'core-js/features/array/find';
import 'core-js/es/object/values';
import 'core-js/es/object/assign';
import 'core-js/es/object/entries';
import 'core-js/es/symbol';
import 'core-js/es/map';
import 'core-js/es/set';

import 'url-search-params-polyfill';
import 'array-flat-polyfill';
import 'whatwg-fetch';
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch';

// home-rolled polyfills.
if (!Element.prototype.matches) {
  //@ts-ignore
  Element.prototype.matches = Element.prototype.msMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function(s: string) {
    var el = this;

    do {
      if (Element.prototype.matches.call(el, s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}

if (!window.BroadcastChannel) {
  //@ts-ignore
  window.BroadcastChannel = class BroadcastChannel {
    name: string;
    constructor(name: string) {
      this.name = 'BroadcastChannel SHIM: no functionality';
    }
    onmessage() {}
    addEventListener() {}
    removeEventListener() {}
    close() {}
    onmessageerror() {}
    dispatchEvent() {}
    postMessage() {}
  };
}

// custom event polyfill
(function() {
  if (typeof window.CustomEvent === 'function') return false;

  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(
      event,
      params.bubbles,
      params.cancelable,
      params.detail
    );
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;

  //@ts-ignore
  window.CustomEvent = CustomEvent;
})();

// find Index polyfill
Array.prototype.findIndex =
  Array.prototype.findIndex ||
  function(callback) {
    if (this === null) {
      throw new TypeError(
        'Array.prototype.findIndex called on null or undefined'
      );
    } else if (typeof callback !== 'function') {
      throw new TypeError('Callback must be a function');
    }
    var list = Object(this);
    var length = list.length >>> 0;
    var thisArg = arguments[1];
    for (var i = 0; i < length; i++) {
      if (callback.call(thisArg, list[i], i, list)) {
        return i;
      }
    }
    return -1;
  };

// array includes polyfill
if (!Array.prototype.includes) {
  Array.prototype.includes = function(search) {
    return !!~this.indexOf(search);
  };
}
